<template>
  <div v-if="prizes.length > 0" class="prizes_swiper_cont">
    <div class="swiper-container prizes-swiper" ref="swiperContainer">
      <div class="swiper-wrapper">
        <div v-for="(prize, index) in prizes"
             :key="index"
             class="swiper-slide"
             :data-swiper-slide-index="index">
          <div class="carousel-item">
            <div class="img_placeholder">
              <img :src="getPrizeImage(prize.type)">
            </div>
            <h4>{{ prizeTypeTranslations[prize.type] || prize.type }} {{ getTranslations.home_leaderboard_carousel_prize }}</h4>
            <p>{{ prize.description }}</p>
          </div>
        </div>
      </div>
      <div v-if="prizes.length > 1" ref="nextButton" class="swiper-button-next"></div>
      <div v-if="prizes.length > 1" ref="prevButton" class="swiper-button-prev"></div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import LeaderboardRank from "../../home/prizesAndLeaderboards/LeaderboardRank";

export default {
  name: 'prize-selection-carousel',
  data() {
    return {
      prizes: [],
      currentPrize: {},
      swiperInstance: null,
    };
  },
  components: {
    LeaderboardRank
  },
  computed: {
    ...mapGetters('profile', [
      'getDailyPrize',
      'getWeeklyPrize',
      'getMonthlyPrize',
      'getGrandPrize',
      'getCarouselPrizes',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    prizeTypeTranslations() {
      return {
        DAILY: this.getTranslations.home_leaderboard_daily_prize,
        WEEKLY: this.getTranslations.home_leaderboard_weekly_prize,
        MONTHLY: this.getTranslations.home_leaderboard_monthly_prize,
        GRAND: this.getTranslations.home_leaderboard_grand_prize,
      };
    }
  },
  mounted() {
    this.populatePrizes();
  },
  watch: {
    // Watch for changes in the prizes to re-initialize swiper if needed
    prizes(newPrizes) {
      if (newPrizes.length > 0) {
        this.initSwiper();
      }
    }
  },
  methods: {
    getPrizeImage(prizeType) {
      if (prizeType === 'DAILY') {
        return this.getDailyPrize.imgUrl;
      } else if (prizeType === 'WEEKLY') {
        return this.getWeeklyPrize.imgUrl;
      } else if (prizeType === 'MONTHLY') {
        return this.getMonthlyPrize.imgUrl;
      } else if (prizeType === 'GRAND') {
        return this.getGrandPrize.imgUrl;
      }
      return ''
    },
    handleSlideChange(swiper) {
      const activeIndex = swiper.realIndex;
      this.currentPrize = this.prizes[activeIndex];
      this.$emit('slide-changed', this.currentPrize.type);
    },
    populatePrizes() {

      this.prizes = this.getCarouselPrizes.map(prize => {
        if (typeof prize === "string") {
          return {
            type: prize,
            description: "No description available"
          };
        }
        return {
          type: prize.type || "UNKNOWN",
          description: prize.description || "No description available"
        };
      });
    },
    initSwiper() {

      this.$nextTick(() => {
        if (!this.$refs.swiperContainer) return;

        this.swiperInstance = new Swiper(this.$refs.swiperContainer, {
          loop: this.prizes.length > 1, // Only enable loop if more than 1 prize
          navigation: this.prizes.length > 1
            ? {
              nextEl: this.$refs.nextButton,
              prevEl: this.$refs.prevButton,
            }
            : false, // This prevents Swiper from attaching navigation
          slidesPerView: 1,
          on: {
            slideChange: (swiper) => {
              this.handleSlideChange(swiper);

            }
          }
        });
        //Emit the type of the first prize after swiper is initialized
        if (this.prizes.length > 0) {
          this.currentPrize = this.prizes[0];
          this.$emit('slide-changed', this.currentPrize.type); // Emit the type of the first prize
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/carousel/PrizeSelectionCarousel.vue